import { navigate } from 'gatsby'
import React, {
  useContext,
  useRef,
  useEffect,
  useCallback,
  useState,
} from 'react'

import { Context } from '../../../context/app-context'
import GameController from '../../../game/SSR-firewall'
import useMediaQuery from '../../../utils/useMediaQuery'
import './game-content.scss'

const gameRef = {
  current: null
}
const InstructionsModal = (scene, handleStartGame) => {
  return {
    type: 'set-modal',
    modalActive: {
      type: 'instructions',
      props: {
        handleStartGame,
        scene,
      },
    },
  }
}
const VideoModal = (onSkipVideo, onFinishVideo) => {
  return {
    type: 'set-modal',
    modalActive: {
      type: 'video',
      wrapperProps: {
        blur: true
      },
      props: {
        pointsToWin: 5,
        onSkipVideo,
        onFinishVideo,
      },
    },
  }
}
const EndGameModal = (points, win) => {
  return {
    type: 'set-modal',
    modalActive: {
      type: 'endGame',
      props: {
        points,
        win
      },
    },
  }
}
const LoginModal = (isMobile, handleStartGame, onClose = () => { }) => {
  return {
    type: 'set-modal',
    modalActive: {
      type: 'login',
      props: {
        close: onClose,
        handleStartGame,
        mobile: isMobile,
      },
    },
  }
}
const GameContent = () => {
  const isMobile = useMediaQuery();
  const containerRef = useRef()
  const { dispatch } = useContext(Context)
  const [childKey, setChildKey] = useState(1);
  var initilSceneName = "";
  const showEndGameModal = (points, win) => {
    dispatch(EndGameModal(points, win));
  };
  const onFinishGame = (dataGame) => {
    //--   console.log('FINISHED GAME', dataGame);
    const { points, win } = dataGame;
    showEndGameModal(points, win);
  };

  const gameBoot = () => {

    if (!gameRef.current) {
     // ..  console.log("GAME BOOT...");
      gameRef.current = new GameController(
        'phaser-container',
        onFinishGame
      )
    }
    if (gameRef.current) {
      gameRef.current.init();
      initilSceneName = gameRef.current.getRandomScene();
      // --  console.log(initilSceneName)
      gameRef.current.start(initilSceneName)
    }

  };

  const showModalVideo = useCallback(() => {
    const play = () => {

      gameRef.current.resume(initilSceneName)
    }
    const onSkipVideoHandler = () => {
      play();
    };
    const onFinishVideoHandler = (pointsToWin) => {
      gameRef.current.addPoints(pointsToWin)
      play();
    };
    dispatch(VideoModal(onSkipVideoHandler, onFinishVideoHandler))
  }, [dispatch, initilSceneName])


  const showInstructionModal = () => {
    gameBoot();
    dispatch(InstructionsModal(initilSceneName, showModalVideo));
  };



  useEffect(() => {


    dispatch(LoginModal(isMobile, showInstructionModal, () => {
      dispatch({ type: 'clear-modal' })
      navigate('/');
    }));
    //  showInstructionModal();
    return () => {
      if (gameRef.current) {
        gameRef.current.destroy();
      }
    }
  }, [gameRef])
 // ..  console.log("RENDERING NOW")
  return (
    <section className={'f-game-content '}>
      <div ref={containerRef} className="f-game-content__container" id="phaser-container">       </div>
    </section>
  )
}

export default GameContent
